import Player from '@/utils/player/index';
import { getEventLogConfig } from '@/utils';

function initPlayer() {
  const config = getEventLogConfig();
  const { logUrl } = config || {};
  return new Player({ logUrl });
}

const player = {
  state: {
    player: initPlayer(),
    globalPlaylist: [],
    hidePlayerBar: false,
    videoPlaylist: [],
  },
  getters: {
    player: state => state.player,
    globalPlaylist: state => state.globalPlaylist,
    hidePlayerBar: state => state.hidePlayerBar,
    videoPlaylist: state => state.videoPlaylist,
  },
  mutations: {
    SET_GLOBAL_PLAY_LIST: (state, data) => {
      state.globalPlaylist = data;
    },
    SET_HIDE_PLAYER_BAR: (state, data) => {
      state.hidePlayerBar = data;
    },
    SET_VIDEO_PLAYLIST: (state, data) => {
      state.videoPlaylist = data;
    },
  },
  actions: {
    toggleGlobalPlayList({ commit }, payload) {
      commit('SET_GLOBAL_PLAY_LIST', payload);
    },
    toggleHidePlayerBar({ commit }, payload) {
      commit('SET_HIDE_PLAYER_BAR', payload);
    },
    toggleVideoPlaylist({ commit }, payload) {
      commit('SET_VIDEO_PLAYLIST', payload);
    },
  },
};

export default player;
